import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useCallback } from 'react';
import { Input } from '../Input/Input.es.js';

const PasswordInput = /*#__PURE__*/ forwardRef(({ locale = {
    hide: 'hide password',
    reveal: 'reveal password'
}, onChange, name = 'password', disabled, value, error, message, label, className, loading, display, warning, emphasize, placeholder, readOnly, labelProps, labelSuffix, ...props }, ref)=>{
    const [isRevealed, setReveal] = useState(false);
    const toggleReveal = useCallback(()=>setReveal((s)=>!s), []);
    return jsx(Input, {
        className: className,
        disabled: disabled,
        display: display,
        emphasize: emphasize,
        error: error,
        label: label,
        labelProps: labelProps,
        labelSuffix: labelSuffix,
        loading: loading,
        message: message,
        placeholder: placeholder,
        readOnly: readOnly,
        value: value,
        warning: warning,
        children: jsx(Input.Field.Text, {
            ref: ref,
            name: name,
            onChange: onChange,
            type: isRevealed ? 'text' : 'password',
            value: value,
            ...props,
            children: jsx(Input.Inline.IconButton, {
                align: "right",
                disabled: disabled,
                label: isRevealed ? locale?.hide : locale?.reveal,
                name: isRevealed ? 'EyeSolid' : 'EyeOffSolid',
                onClick: toggleReveal
            })
        })
    });
});
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput, PasswordInput as default };
//# sourceMappingURL=PasswordInput.es.js.map
